module.exports = __webpack_public_path__ + "img/logo_x2.96e8817b.webp";